import GraphPage from './Page/GraphPage';

export const Pages = {
  GraphPage
};
